import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../AuthContext';

export default function SetPassword() {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setSubmitting(true);
    const { error } = await supabase.auth.updateUser({ password });
    setSubmitting(false);
    if (error) {
      setError(error.message);
    } else {
      setDone(true);
      setTimeout(() => navigate('/'), 1500);
    }
  };

  if (loading) {
    return (
      <div className="login-page">
        <div className="login-card"><p>Loading…</p></div>
      </div>
    );
  }

  if (!session) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-brand">
            <span className="login-brand__hc">HOBBY CITY</span>
            <span className="login-brand__admin">ADMIN</span>
          </div>
          <p>This link has expired or is invalid. Ask an administrator to send a new one.</p>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="login-page">
        <div className="login-card"><p>Password set — redirecting…</p></div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-brand">
          <span className="login-brand__hc">HOBBY CITY</span>
          <span className="login-brand__admin">ADMIN</span>
        </div>
        <p className="login-subtitle">Set your password</p>

        <label className="login-label" htmlFor="set-password-new">New Password</label>
        <input
          id="set-password-new"
          className="login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          autoComplete="new-password"
        />

        <label className="login-label" htmlFor="set-password-confirm">Confirm Password</label>
        <input
          id="set-password-confirm"
          className="login-input"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
        />

        {error && <div className="login-error">{error}</div>}

        <button className="login-btn" type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : 'Set Password'}
        </button>
      </form>
    </div>
  );
}
